<template>
    <div>
        <h1 class="text-center mt-4 d-none d-lg-block">Bienvenido al sistema de facturaci&oacute;n en l&iacute;nea <br> de EDÉN ABASTOS DE MTY SA DE CV
        </h1>
        <h4 class="text-center mt-4 d-lg-none">Bienvenido al sistema de facturaci&oacute;n en l&iacute;nea <br> de EDÉN ABASTOS DE MTY SA DE CV
        </h4>
        <div class="card mt-lg-5 mt-3">
            <div class="card-header text-center bg-custom text-white h5">
                <b-icon icon="info-circle"></b-icon>
                Ponemos a su disposici&oacute;n nuestro portal en l&iacute;nea para agilizar el proceso de facturaci&oacute;n
            </div>
            <div class="card-body px-md-5 py-4">
                <p class="card-text">¡Bienvenidos al portal de facturación electrónica de El Edén! Solo necesitan ingresar los datos de su compra y en pocos pasos obtendrás tu factura. Nuestro sitio está diseñado para brindarte una experiencia ágil y segura, cumpliendo con los requisitos del SAT. 
 Será necesario que los siguientes datos y condiciones sean fieles a su Constancia de Situación Fiscal actual:</p>
                <ul>
                    <li>Datos requeridos:
                        <ul>
                            <li>RFC</li>
                            <li>Razón Social</li>
                            <li>USO del CFDI</li>
                            <li>Código postal</li>
                            <li>Régimen Fiscal</li>
                        </ul>
                    </li>
                    <li>Así mismo le informamos que: El plazo para la emisión de su factura será a más tardar el décimo día natural del mes siguiente al que realizó su compra. </li>
                    <li>El servicio de facturación solo permite una factura por nota de venta.</li>
                    <li>Le sugerimos revisar que la información ingresada sea la correcta.</li>
                    <li>En caso de correcciones o modificaciones tiene que comunicarse a la sucursal donde realizó su compra.</li>
                </ul>
                
                <router-link tag="a" :to="{ name: 'Invoice' }" class="btn btn-custom">
                    <b>Facturar</b>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'StartAhued',
    }
    
</script>

